import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";

// An action's label is either free text or one of these two icons. There's no dedicated backend field
// for this — `answer_value` stays a plain string end-to-end, and these are reserved marker values that
// mean "render as an icon instead of text" wherever a label is shown. Any other `answer_value`
// (including everything saved before this feature existed) is just free text, as before.
export const CARD_ACTION_ICON_CHECK = "__icon:check__";
export const CARD_ACTION_ICON_TIMES = "__icon:times__";

export const cardActionIcons: Record<string, typeof faCircleCheck> = {
  [CARD_ACTION_ICON_CHECK]: faCircleCheck,
  [CARD_ACTION_ICON_TIMES]: faCircleXmark,
};

export function cardActionIconFor(answerValue: string): typeof faCircleCheck | null {
  return cardActionIcons[answerValue] ?? null;
}
